import { Component, ViewChild } from '@angular/core';
import { FormularioMagnitudesComponent } from './formulario-magnitudes/formulario-magnitudes.component';
import { MatTableDataSource } from '@angular/material/table';
import { properties } from '@/utils/properties';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CatalogoMagnitudesService } from '@services/catalogo/catalogoMagnitudes.service';
import { MatDialog } from '@angular/material/dialog';
import { Util } from '@/utils/util';
import { MagnitudesModel } from '@/store/catalogos/magnitudes';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-magnitudes',
  templateUrl: './magnitudes.component.html',
  styleUrls: ['./magnitudes.component.scss']
})
export class MagnitudesComponent {
PROP = properties;
  displayedColumns: string[] = ['nombreMagnitud', 'options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private magnitudService: CatalogoMagnitudesService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this. loadMagnitud();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadMagnitud() {
    this.magnitudService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioMagnitudesComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:null}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadMagnitud();
      }
    });
  }

  update(row: MagnitudesModel) {
    const dialogRef = this.dialog.open(FormularioMagnitudesComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:true,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadMagnitud();
      }
    });
  }

  view(row: MagnitudesModel) {
    const dialogRef = this.dialog.open(FormularioMagnitudesComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:false,view:true,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadMagnitud();
      }
    });
  }
}
